module.exports = __webpack_public_path__ + "static/media/error-404.6d089193.svg";